// Added by Sejune Oh on 2019-02-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Component } from 'react'
import { observer } from 'mobx-react'
import { observable, action, computed, makeObservable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Define
import { ReactInputChangeEvent, ReactEmptyEvent, ReactKeyUpEvent, ReactKeyPressEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Components
import SearchElem, { SearchBaseFCProps } from './Search'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface SearchCProps extends SearchBaseFCProps {
  onSearch: (key: string) => void
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
@observer
class SearchContainer extends Component<SearchCProps> {
  _keyword: string = ''
  isOnPress: boolean = false

  _btnId = 'search-btn'
  _inputTimer: any

  constructor(props: SearchCProps) {
    super(props)
    makeObservable(this, {
      _keyword: observable,
      isOnPress: observable,
      keyword: computed,
      handleValueChage: action,
      _handleKeyUp: action,
      _handleKeyPress: action,
    })
  }

  render() {
    return (
      <SearchElem
        {...this.props}
        onBtnClick={this.handleSearchBtnClick}
        onChange={this.handleValueChage}
        onKeyUp={this._handleKeyUp}
        onKeyPress={this._handleKeyPress}
        btnId={this._btnId}
      />
    )
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  get keyword() {
    return this._keyword
  }

  handleValueChage: ReactInputChangeEvent = ({ currentTarget: { value } }) => {
    this._keyword = value

    if (this._inputTimer) {
      clearTimeout(this._inputTimer)
    }

    this._inputTimer = setTimeout(() => {
      if (!this.isOnPress) this.props.onSearch(this._keyword)
    }, 800)
  }

  updateSearchKeyword = (key: string) => {
    ;(document.getElementById('search-input') as HTMLInputElement).value = key
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Do task with searched keyword
  handleSearchBtnClick: ReactEmptyEvent = () => {
    this.props.onSearch(this._keyword)
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  _handleKeyUp: ReactKeyUpEvent = (event) => {
    if (event.keyCode === 13) {
      if (this._inputTimer) {
        clearTimeout(this._inputTimer)
      }

      this.handleSearchBtnClick()
    }

    this.isOnPress = false
  }

  _handleKeyPress: ReactKeyPressEvent = () => {
    this.isOnPress = true
  }
}

export default SearchContainer
